import { ApexOptions } from 'apexcharts';

import { ObjectTraps, TotalTrapsCaptureChartData } from 'api/analitics/types';
import { TFunction } from 'i18next';
import './5totalTrapsCapturesChart.scss';

interface ChartData {
  series: number[];
  labels: string[];
}

const formatPercent = (value: number): string => {
  if (Math.round(value * 100) / 100 >= 100) return '100%';

  if (value > 0 && value < 0.005) return '<0.01%';
  if (value >= 99.995) return '>99.99%';

  return `${value.toFixed(2)}%`;
};

export const totalTrapsCaptureChartOptions = (
  t: TFunction,
  objectTraps: ObjectTraps,
  totalTrapsCapture?: TotalTrapsCaptureChartData,
) => {
  const mctCount = totalTrapsCapture?.mct_amount || 0;
  const smstCount = totalTrapsCapture?.smst_amount || 0;
  const totalCaptures = mctCount + smstCount;

  // Build series as RAW COUNTS (Apex calculates percentages from series itself)
  const series: number[] = [];
  if (objectTraps.mct.was_ever_installed) series.push(mctCount);
  if (objectTraps.smst.was_ever_installed) series.push(smstCount);

  const labels: string[] = [];
  if (objectTraps.mct.was_ever_installed) labels.push(t('ChartsAnalitics.total_traps_capture_chart.chart_label_mct'));
  if (objectTraps.smst.was_ever_installed) labels.push(t('ChartsAnalitics.total_traps_capture_chart.chart_label_smst'));

  const chartData: ChartData = {
    series,
    labels,
  };

  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    colors: ['#6A37D4', '#FFE529'],
    series: chartData.series,
    labels: chartData.labels,
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      cssClass: 'tooltipData',
      custom: (opts: any) => {
        const seriesIndex = opts.seriesIndex;
        return `Total ${seriesIndex === 0 ? 'MCT' : 'SMST'} Trap Capture: ${seriesIndex === 0 ? `${totalTrapsCapture?.mct_amount}` : `${totalTrapsCapture?.smst_amount}`}`;
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#ffffff'], // Додаємо білий колір для тексту
      },
      formatter: (_val: number, opts: any) => {
        const idx = opts.seriesIndex as number;
        const value = chartData.series[idx] ?? 0;

        if (!totalCaptures || totalCaptures <= 0) return '';

        const percent = (value / totalCaptures) * 100;

        // keep your old behavior: hide labels under 5% (but still clamp display when shown)
        if (percent < 5) return '';

        return formatPercent(percent);
      },
    },
    fill: {
      type: 'gradient',
    },
    responsive: [
      {
        breakpoint: 636,
        options: {
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
        },
      },
    ],
  };

  return chartOptions;
};
